import { render, staticRenderFns } from "./addProgram.vue?vue&type=template&id=8e48ed9c"
import script from "./addProgram.vue?vue&type=script&lang=js"
export * from "./addProgram.vue?vue&type=script&lang=js"
import style0 from "./addProgram.vue?vue&type=style&index=0&id=8e48ed9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports